/**
 * Remove all or specified parameter from url
 * @param url
 * @param {String | Undefined} parameter parameter to remove. If undefined then all parameters will be removed
 * @returns {*}
 */
export const removeQueryStringParameter = function(url, parameter) {
    if (typeof url === "undefined") {
        return "";
    }
    
    const urlParts = url.split("?");
    if (urlParts.length >= 2) {
        if (typeof parameter === "undefined") {
            return urlParts[0];
        }
        
        const prefix = `${encodeURIComponent(parameter)}=`;
        const pars = urlParts[1].split(/[&;]/g);
        
        // Notice reverse iteration here
        for (let i = pars.length; i-- > 0;) {
            if (pars[i].toLowerCase().lastIndexOf(prefix.toLowerCase(), 0) !== -1) {
                pars.splice(i, 1);
            }
        }
        
        url = urlParts[0] + (pars.length > 0 ? `?${pars.join("&")}` : "");
        return url;
    }
    
    return url;
};
